interface HeroSectionProps {
  onRequestAccess: () => void
  onLogin: () => void
}

export default function HeroSection({ onRequestAccess, onLogin }: HeroSectionProps) {
  return (
    <section className="mf-hero">
      <div className="mf-hero-inner">
        <div className="mf-hero-content">
          <div className="mf-hero-badge mf-animate-fade-up">
            <span className="mf-hero-badge-dot" />
            Trusted by 100+ Dairies
          </div>

          <h1 className="mf-animate-fade-up mf-delay-1">
            Powering Smarter<br />
            <span className="mf-highlight">Dairy Subscriptions.</span>
          </h1>

          <p className="mf-animate-fade-up mf-delay-2">
            MilkFlow helps dairies manage subscribers, milk subscriptions,
            deliveries, products, payments and customers — all from one simple platform.
          </p>

          <div className="mf-hero-ctas mf-animate-fade-up mf-delay-3">
            <button className="mf-btn-primary-lg" onClick={onRequestAccess}>
              Get Started
            </button>
            <button className="mf-btn-secondary-lg" onClick={onLogin}>
              Login
            </button>
          </div>
        </div>

        <div className="mf-dashboard-wrap mf-animate-fade-up mf-delay-2">
          <div className="mf-dashboard">
            <div className="mf-dashboard-header">
              <div className="mf-dashboard-header-left">
                <h3>MilkFlow Dashboard</h3>
                <p>Overview — Today</p>
              </div>
              <div className="mf-dashboard-dots">
                <span /><span /><span />
              </div>
            </div>

            <div className="mf-dashboard-stats">
              <div className="mf-stat-card">
                <div className="mf-stat-icon" style={{ background: '#eff6ff', color: '#2563eb' }}>👥</div>
                <div className="mf-stat-value">1,248</div>
                <div className="mf-stat-label">Active Subscribers</div>
              </div>
              <div className="mf-stat-card">
                <div className="mf-stat-icon" style={{ background: '#ecfdf5', color: '#047857' }}>🚚</div>
                <div className="mf-stat-value">986</div>
                <div className="mf-stat-label">Today's Deliveries</div>
              </div>
              <div className="mf-stat-card">
                <div className="mf-stat-icon" style={{ background: '#fef3c7', color: '#d97706' }}>💰</div>
                <div className="mf-stat-value">₹4.82L</div>
                <div className="mf-stat-label">Monthly Revenue</div>
              </div>
              <div className="mf-stat-card">
                <div className="mf-stat-icon" style={{ background: '#fce7f3', color: '#db2777' }}>📦</div>
                <div className="mf-stat-value">32</div>
                <div className="mf-stat-label">Pending Orders</div>
              </div>
            </div>
          </div>

          <div className="mf-float-card mf-float-card-1">
            <div className="mf-float-value">98%</div>
            <div className="mf-float-label">Delivery Rate</div>
          </div>
          <div className="mf-float-card mf-float-card-2">
            <div className="mf-float-value">Active</div>
            <div className="mf-float-label">Subscription</div>
          </div>
        </div>
      </div>
    </section>
  )
}
